import React, { useState } from "react";
// eslint-disable-next-line no-unused-vars
import { Modal, Button, Container, Row, Col, Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import useVipApiFetcher from "Utils/Hooks/useVipApiFetcher";
import "./CancelButton.scss";
import useSession from "Utils/Hooks/useSession";
import useCancelRedirect from "Utils/Hooks/useCancelRedirect";

const CancelButton = ({ btnText, stage }) => {
  const vipApi = useVipApiFetcher();
  const history = useHistory();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const handleClose = (event) => {
    if (event) event.preventDefault();
    setShowConfirmation(false);
  };
  const handleShow = () => setShowConfirmation(true);
  const { session, invalidateSession } = useSession();
  const url = useCancelRedirect() ?? session?.cancelRedirectUrl;

  const style = {
    width: "100%",
    marginTop: "20px",
  };

  async function onSuccess() {
    window.sessionStorage.setItem("IsRedirectOrCancel", true);
    window.sessionStorage.setItem("plaidlaunch", false);
    if (url) {
      window.location.replace(url);
    } else {
      if (window.opener !== null && !window.opener.closed) {
        window.close();
      }
      else if (window.opener === null) {
        invalidateSession();
        history.push("/logout");
      }
      else if (
        window.parent !== null &&
        window.parent.frames !== null &&
        window.parent.frames.length > 0
      ) {
        window.parent.postMessage("close", "*");
      } else {
        if (/android/i.test(navigator.userAgent)) {
          if (typeof window !== undefined) {
            window.postMessage("close", "*");
          } else if (document !== undefined) {
            document.postMessage("close", "*");
          }
        } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
          window.postMessage("close", "*");
        } else {
          invalidateSession();
          history.push("/logout");
        }
      }
    }
  }

  function onError(response) {
    history.push({
      pathname: '/error',
      state: {
        isError: true,
        showButton: true,
        title: "Request Failed. Please Try Again",
        message: response.patronErrorMessage ?? "Your Cancel Request Failed. Please Try Again",
        allowRetry: false
      }
    });
  }
  async function onSubmit(event) {
    event.preventDefault();
    vipApi
      .fetch("/api/usertracking/cancelflow", "POST", {
        transactionStage: stage,
      })
      .then((response) => {
        if (response.ok) {
          onSuccess();
        } else {
          if (response.status === 500) {
            console.error(response.statusText);
            history.push({
              pathname: "/error",
            });
          } else if (response.status === 401) {
            console.error(response.statusText);
            history.push({
              pathname: "/expired",
            });
          } else {
            response.json().then((data) => {
              console.error(data);
              onError(data);
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
        history.push({
          pathname: "/error",
        });
      });
  }
  const bodyText = "Are you sure you want to Cancel?";
  return (
    <>
      <button className="link text-center click-cancel" style={style} onClick={handleShow}>
        Cancel {btnText}
      </button>
      <Modal
        show={showConfirmation}
        onHide={handleClose}
        className="cancel-confirmation"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Container>
              <Row>
                <Col className="text-center cancel-text">{bodyText}</Col>
              </Row>
              <Row>
                <Col>
                  <button className="submit-button click-cancel-yes" onClick={onSubmit}>
                    YES
                  </button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <button className="submit-button click-cancel-no" onClick={handleClose}>
                    NO
                  </button>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CancelButton;
